export default {
  DEFAULT: 'L',
  BE_FILTERING: 'YYYY-MM-DD',
  WITH_TIME: 'L hh:mm:ss A',
  WITH_UTC_TIME: 'YYYY-MM-DD UTC HH:mm:ss',
  ONLY_TIME: 'hh:mm A',
  ONLY_24TIME: 'HH:mm:ss',
  TIMESTAMP: 'hh:mm A MMMM DD YYYY',
};
